import { supabase } from '@/core/database/supabase';
import type { 
  ConstructionReportSummary, 
  ProgressReportItem,
  QaReportItem,
  CostReportItem,
  ReportFilters 
} from '../types/construction-reports.types';

export const ConstructionReportsService = {
  /**
   * Tổng quan báo cáo thi công
   */
  async getOverview(companyId: string, projectId?: string): Promise<ConstructionReportSummary> {
    // Logic thực tế sẽ gọi các RPC hoặc View tổng hợp
    // Ở đây giả lập dữ liệu dựa trên các service đã có
    return {
      totalProjects: 5,
      overallProgress: 68,
      totalBudget: 15000000000,
      actualCost: 10200000000,
      pendingIssues: 12,
      failedQaCount: 4,
      materialUsagePercent: 82,
      equipmentUtilization: 75,
    };
  },

  /**
   * Báo cáo tiến độ chi tiết
   */
  async getProgressReport(companyId: string, filters: ReportFilters): Promise<ProgressReportItem[]> {
    let query = supabase
      .from('vw_construction_progress_report') // Giả định view tồn tại
      .select('*')
      .eq('company_id', companyId);

    if (filters.projectId) query = query.eq('project_id', filters.projectId);

    const { data, error } = await query;
    if (error) {
      // Nếu view chưa có, trả về dữ liệu mẫu để dev UI
      return [
        { id: '1', name: 'Thi công phần thô', type: 'phase', planned_progress: 90, actual_progress: 85, variance: -5, status: 'delayed' },
        { id: '2', name: 'Lắp đặt hệ thống tưới', type: 'boq', planned_progress: 50, actual_progress: 55, variance: 5, status: 'ahead' },
      ];
    }
    return data as ProgressReportItem[];
  },

  /**
   * Báo cáo QA
   */
  async getQaReport(companyId: string, filters: ReportFilters): Promise<QaReportItem[]> {
    // Logic aggregation từ construction_qa_inspections
    return [
      { inspection_type: 'Vật tư đầu vào', total_inspections: 45, passed_count: 42, failed_count: 3, pass_rate: 93.3 },
      { inspection_type: 'Lắp đặt kỹ thuật', total_inspections: 30, passed_count: 25, failed_count: 5, pass_rate: 83.3 },
    ];
  },

  /**
   * Báo cáo chi phí
   */
  async getCostReport(companyId: string, filters: ReportFilters): Promise<CostReportItem[]> {
    return [
      { category: 'Nhân công', budget: 5000000000, actual: 4800000000, variance: 200000000, utilization: 96 },
      { category: 'Vật tư', budget: 8000000000, actual: 7200000000, variance: 800000000, utilization: 90 },
      { category: 'Máy thi công', budget: 2000000000, actual: 2100000000, variance: -100000000, utilization: 105 },
    ];
  }
};
